











































































































































import { defineComponent, reactive, SetupContext, ref, toRef, toRefs, watch, onMounted } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { Student, StudentListCondition, PasswordForm } from "../../modules/teacher/StudentList"

export interface Data {
  condition: StudentListCondition
  students: Student[]
  totalCount: number
  isShow: boolean
  delete_ids: string[]
  isAllCheckedDelete: boolean
  modalStudent: PasswordForm
  errors: string[]
  modalErrors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * ref
     ******************************/
    const modalResetPasswordRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: new StudentListCondition(),
      students: new Array<Student>(),
      totalCount: 0,
      isShow: false,
      delete_ids: [],
      isAllCheckedDelete: false,
      modalStudent: new PasswordForm(new Student({})),
      errors: [],
      modalErrors: []
    });

    /******************************
     * methods
     ******************************/

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      state.delete_ids = [];
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/student_list?${Common.BuildQuery(state.condition, 'search_student')}`).then(response => {
        state.students = response.data.students.map((x: any) => new Student(x));
        state.totalCount = state.students.length > 0 ? state.students[0].at_full_count : 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new StudentListCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * パスワードモーダル表示
     ******************************/

    const showPasswordModal = (student: Student) => {
      state.modalStudent = new PasswordForm(student);
      modalResetPasswordRef.value.show();
    };

    /******************************
     * パスワードモーダル閉じる
     ******************************/

    const closePasswordModal = () => {
      modalResetPasswordRef.value.hide();
    };

    /****************************************
     * パスワードリセット
     ****************************************/
    
    const updatePassword = async () => {

      if(!validate() || !window.confirm("パスワードを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.patch(`/api/student_list/update_password/${state.modalStudent.user_id}`, {student: state.modalStudent}).then(response => {
        alert("パスワードの変更が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
      modalResetPasswordRef.value.hide();
    };

    /******************************
     * バリデーション
     ******************************/

    const validate = () => {

      state.modalErrors = [];

      if (state.modalStudent.password === "") {
        state.modalErrors.push("新しいパスワードは必須です。");
      }

      if (state.modalStudent.password_confirmation === "") {
        state.modalErrors.push("新しいパスワード（確認）は必須です。");
      }

      if (state.modalStudent.password != state.modalStudent.password_confirmation) {
        state.modalErrors.push("パスワードが一致しません。");
      }

      return state.modalErrors.length == 0;
    };

    /******************************
     * 全選択（削除）
     ******************************/

    const checkAllDelete = () => {

      state.delete_ids = [];
      if (state.isAllCheckedDelete) {
        state.isAllCheckedDelete = false;
      } else {
        state.students.forEach((x: Student) => state.delete_ids.push(String(x.user_id)));
        state.isAllCheckedDelete = true;
      }
    };
    
    /****************************************
     * 生徒削除
     ****************************************/
    
    const studentDelete = async () => {

      if (state.delete_ids.length == 0) {
        alert('削除する生徒をチェックしてください。');
        return;
      }
      if (!confirm('本当に削除してもよろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/student_list/students_delete`, {user_ids: state.delete_ids}).then(response => {
        alert("削除処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
      window.location.reload();
    };

    /****************************************
     * 指定されたページに遷移
     ****************************************/
    
    const to = (page: string) => {
      context.root.$router.push(page).catch(err => {});
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition.nendo = context.root.$store.getters.getCurrentNendo();
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      modalResetPasswordRef,
      searchClick,
      search,
      clearCondition,
      changePage,
      showPasswordModal,
      closePasswordModal,
      updatePassword,
      checkAllDelete,
      studentDelete,
      to,
    };
  },
})
